<template>
  <b-container class="alert-dialog">
    <div class="close-btn">
      <slot></slot>
    </div>
    <b-row class="mt-4" align-h="center">
      {{ this.message }}
    </b-row>
    <slot name="formInput"></slot>
    <slot name="errorMsg"></slot>
    <b-row class="mt-4" align-h="center">
      <slot name="currentPlan"></slot>
    </b-row>
    <b-row class="mt-4" align-h="center">
      <slot name="pricing-options"></slot>
    </b-row>
    <b-row class="mt-5" align-h="center">
      <div class="btn-alert">
        <slot name="successBtn"></slot>
      </div>

      <div class="btn-alert">
        <slot name="cancelBtn"></slot>
      </div>
    </b-row>
  </b-container>
</template>

<script>
export default {
  props: ['message'],
  data() {
    return {

    }
  },
}
</script>

<style scoped>
.close-btn {
  position: absolute;
  top: 0;
  right: 0;
}

.btn-alert {
  margin: 0 10px;
}
</style>
